import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/wri-logo-v1.gif")